import { Slot } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

import { type BadgeVariantProps, badgeVariants } from "./badgeVariants";

type BadgeProps = ComponentProps<"span"> &
  BadgeVariantProps & {
    asChild?: boolean;
  };

export const Badge = ({ className, variant, asChild = false, ...props }: BadgeProps) => {
  const Component = asChild ? Slot.Root : "span";
  return (
    <Component data-slot="badge" className={cn(badgeVariants({ variant }), className)} {...props} />
  );
};
